export default __webpack_public_path__ + "static/media/ninetypercent.07d7fc18.gif";